export default {
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': {
      padding: '0 8px',
    },
  },
};
